<template>
  <v-container
    id="payGroupTab"
    class="pa-0"
  >
    <base-resource-grid
      color="green"
      icon="mdi-currency-usd"
      plural-name="Pay Groups"
      singular-name="Pay Group"
      allow-expand
      :headers="gridHeaders"
      :resource="payGroupResource"
      :fetch-method="getPayGroups"
      :actions="actions"
      :prepare-save="prepareSave"
      :disabled="disabled"
      @handleAction="handleAction"
      @item:updated="itemChanged"
      @item:deleted="itemChanged"
      @item:added="itemChanged"
    >
      <template v-slot:editForm="bindings">
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.payGroup"
              :error-messages="bindings.formErrors.PayGroup"
              :disabled="disabled"
              label="Pay Group"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.payFrequency"
              :error-messages="bindings.formErrors.PayFrequency"
              :disabled="disabled"
              label="Pay Frequency"
              type="number"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.deductionFrequency"
              :error-messages="formErrors.DeductionFrequency"
              :disabled="disabled"
              label="Deduction Frequency"
              type="number"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <base-date-picker
              :date-value.sync="bindings.editedItem.firstPayrollCutoff"
              :error-messages="bindings.formErrors.FirstPayrollCutoff"
              :disabled="disabled"
              label="First Payroll Cutoff"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <base-date-picker
              :date-value.sync="bindings.editedItem.firstPayDate"
              :error-messages="bindings.formErrors.FirstPayDate"
              :disabled="disabled"
              label="First Pay Date"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.ongoingCutoff"
              :error-messages="bindings.formErrors.OngoingCutoff"
              :disabled="disabled"
              label="Ongoing Cutoff"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <base-section-dropdown
              :value.sync="bindings.editedItem.deduction"
              section="OE PayGroup - Deduction"
              :error-messages="bindings.formErrors.Deduction"
              :disabled="disabled"
              label="Deduction"
            />
          </v-col>
        </v-row>
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="oePayGroupHistory/"
      id-field="oePayGroupId"
      title-field="payGroup"
      color="green"
      :columns="historyColumns"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'PayGroupTab',

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      gridHeaders: [
        {
          text: 'Pay Group',
          value: 'payGroup',
        },
      ],

      historyColumns: [
        {
          text: 'Pay Group',
          value: 'payGroup',
        },
        {
          text: 'Pay Frequency',
          value: 'payFrequency',
        },
        {
          text: 'Deduction Frequency',
          value: 'deductionFrequency',
        },
        {
          text: 'First Payroll Cutoff',
          value: 'firstPayrollCutoff',
        },
        {
          text: 'First Pay Date',
          value: 'firstPayDate',
        },
        {
          text: 'Ongoing Cutoff',
          value: 'ongoingCutoff',
        },
        {
          text: 'Deduction',
          value: 'deduction',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      payGroupResource: new TroodyApi('oePayGroup/'),

      historyItem: null,
    }),

    methods: {
      getPayGroups () {
        return this.payGroupResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },

      itemChanged (data) {
        this.$emit('item:changed', data)
      },

      prepareSave (payload) {
        if (payload) {
          payload.openEnrollmentId = this.openEnrollment.id

          // Convert strings to numbers safely
          payload.payFrequency = ((payload || {}).payFrequency === undefined ? null : payload.payFrequency * 1)
          payload.deductionFrequency = ((payload || {}).deductionFrequency === undefined ? null : payload.deductionFrequency * 1)
        }
        return payload
      },
    },
  }
</script>
